export default {
  "htmlComponent": "JguOA",
  "htmlComponent_placeholder": "Jsfr5"
};